/* eslint-disable import/extensions */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/prefer-default-export */
import {
  getCookie,
  isEmpty,
  path,
  sendSigninDeviceIdNativeAndroidCallback,
  sendSigninDeviceIdNativeIosCallback
} from '../utils/common'
import { personalization } from './deviceIdApi'

export const deviceId = async () => {
  const params = new Proxy(new URLSearchParams(path(['location', 'search'], window)), {
    get: (searchParams, prop) => searchParams.get(prop)
  })
  let deviceType = params?.isAndroidApp === 'true' ? 'AndroidApp' : params?.isIosApp === 'true' ? 'iPhoneApp' : 'pwa'
  const userAgent = path(['navigator', 'userAgent'], window)?.toLowerCase()
  const ios = /iphone|ipod|ipad/.test(userAgent)
  const safari = /safari/.test(userAgent)
  if (
    deviceType === 'iPhoneApp' ||
    (params?.isMobileApp === 'true' && params?.deviceType === 'ios') || // home page
    (typeof window?.sessionStorage !== 'undefined' && window.sessionStorage?.getItem('mobileApp') === 'iPhoneApp') || (ios && !safari) || params?.isIosApp === 'true' // deeplink
  ) {
    deviceType = 'iOS'
  } else if (deviceType === 'AndroidApp') {
    deviceType = 'Android'
  } else {
    deviceType = 'pwa'
  }
  window.check2 = deviceType
  const localStorageDeviceId =
        deviceType === 'iOS' ? window?.sessionStorage?.getItem('dvid') : window?.localStorage?.getItem('dvid')
  const getDeviceIdCookie = getCookie('ct-dvId') || ''
  let req
  const IOS_RETRY_INTERVAL = 500
  let IOS_COUNT = 1
  // doing for pwa/desktop
  try {
    if (isEmpty(localStorageDeviceId) && isEmpty(getDeviceIdCookie)) {
      if (deviceType === 'iOS') {
        const iosTimer = setInterval(async () => {
          if (path(['iosData'], window)) {
            clearInterval(iosTimer)
            req = await personalization()
            const { status, headers } = req
            if (status === 204) {
              // ios case session storage
              const iOSDeviceId = window?.iosData?.device_id || headers.dvid
                          window?.sessionStorage?.setItem('dvid', iOSDeviceId)
                          sendSigninDeviceIdNativeIosCallback()
            }
          }
          if (IOS_COUNT >= 20) {
            clearInterval(iosTimer)
          }
          IOS_COUNT += 1
        }, IOS_RETRY_INTERVAL)
      } else {
        req = await personalization()
        const { status, headers } = req
        if (status === 204) {
          if (deviceType !== 'pwa') {
            // mobile check
            if (deviceType === 'Android') {
              window.androidData = JSON.parse(window?.MobileApp?.getAppSpecificData()) || {}
              const androidDeviceId = window?.androidData.device_id || headers.dvid
                            window?.localStorage?.setItem('dvid', androidDeviceId)
                            sendSigninDeviceIdNativeAndroidCallback()
            }
          } else {
                        window?.localStorage?.setItem('dvid', headers.dvid) // pwa case
          }
        }
      }
    } else if (isEmpty(localStorageDeviceId) && !isEmpty(getDeviceIdCookie) && deviceType === 'pwa') {
      req = await personalization()
      const { status, headers } = req
      if (status === 204) {
                window?.localStorage?.setItem('dvid', headers.dvid)
      }
    } else if (!isEmpty(localStorageDeviceId) && isEmpty(getDeviceIdCookie)) {
      if (deviceType === 'iOS') {
        const iosTimer = setInterval(async () => {
          if (path(['iosData'], window)) {
            clearInterval(iosTimer)
            req = await personalization(localStorageDeviceId)
            sendSigninDeviceIdNativeIosCallback()
          }
          if (IOS_COUNT >= 20) {
            clearInterval(iosTimer)
          }
          IOS_COUNT += 1
        }, IOS_RETRY_INTERVAL)
      } else {
        req = await personalization(localStorageDeviceId)
        const { status, headers } = req
        if (deviceType === 'Android') {
          if (status === 204) {
            // ios case session storage
            const androidDeviceId = window?.androidData?.device_id || headers.dvid
        // when android dosent give it's deviceId then storage from api
        window?.localStorage?.setItem('dvid', androidDeviceId)
        sendSigninDeviceIdNativeAndroidCallback()
          }
        }
      }
    }
  } catch (e) {
    console.error(e)
  }
}
